import React from "react";
import "./components/Industries.css";

import techIcon from "../../assets/images/industries/tech.png";
import consumerIcon from "../../assets/images/industries/consumer.png";
import professionalIcon from "../../assets/images/industries/professional.png";
import startupIcon from "../../assets/images/industries/startup.png";
import researchIcon from "../../assets/images/industries/research.png";
import founderIcon from "../../assets/images/industries/founder.png";
import advisoryIcon from "../../assets/images/industries/advisory.png";

const IndustriesPage = () => {
  return (
    <section className="industries-page">

      {/* HERO */}
      <div className="container industries-hero">
        <h1>Industries We Can Support</h1>

        <p>
          Our capabilities are cross-functional and adaptable across sectors
          where strategy, technology, market understanding, and execution matter.
        </p>
      </div>

      {/* GRID */}
      <div className="container industries-grid">

        <div className="industry-card">
          <img src={techIcon} alt="" />
          <h3>Technology and AI-enabled businesses</h3>
          <div className="yellow-line"></div>
        </div>

        <div className="industry-card">
          <img src={consumerIcon} alt="" />
          <h3>Consumer and digital brands</h3>
          <div className="yellow-line"></div>
        </div>

        <div className="industry-card">
          <img src={professionalIcon} alt="" />
          <h3>Professional services firms</h3>
          <div className="yellow-line"></div>
        </div>

        <div className="industry-card">
          <img src={startupIcon} alt="" />
          <h3>Innovation-led startups</h3>
          <div className="yellow-line"></div>
        </div>

        <div className="industry-card">
          <img src={researchIcon} alt="" />
          <h3>Research and insight-driven organizations</h3>
          <div className="yellow-line"></div>
        </div>

        <div className="industry-card">
          <img src={founderIcon} alt="" />
          <h3>Founder-led growth businesses</h3>
          <div className="yellow-line"></div>
        </div>

        <div className="industry-card">
          <img src={advisoryIcon} alt="" />
          <h3>Advisory, media, and communications-oriented businesses</h3>
          <div className="yellow-line"></div>
        </div>

      </div>

    </section>
  );
};

export default IndustriesPage;